<template>
  <div class="container">

    <div class="top">
      <input class="filter" ref="filter" v-model="filter" placeholder="Filtrer les épisodes" />
      <div class="icon-search" @click="searchEvent">
        <svg aria-hidden="true" viewBox="0 0 512 512" v-show="filter.length === 0" style="margin-right: 0px"><path fill="black" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z" class=""></path></svg>
        <svg aria-hidden="true" viewBox="0 0 352 512" v-show="filter.length > 0" style="margin-right: 5px"><path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z" class=""></path></svg>
      </div>
    </div>

    <ul class="episodes">
      <li v-for="(episode, index) in filteredEpisodes"
          :key="episode.id"
          :data-pair="index % 2 === 0"
          :data-current="episode === currentEpisode"
          class="episode"
          :id="episode.id"
          :ref="episode.id"
          @click="addEpisode(episode, true)">
        {{episode.name}}
        <span class="category" v-if="episode.category">{{episode.category}}</span>
      </li>
    </ul>
    <div class="no-episodes"
          v-if="filteredEpisodes.length === 0">
      Aucun épisode trouvé.<br />
      Veuillez vider le filtre pour continuer.
    </div>
  </div>
</template>

<script>
import scrollTo from '@/services/scrollTo.js'
import episodes from '@/services/episodes.js'
export default {
  name: 'episodes',
  props: ['currentEpisode'],
  data () {
    return {
      episodes: episodes.list(),
      filter: '',
      formerEpisodes: []
    }
  },
  computed: {
    filteredEpisodes () {
      const lowerCaseFilter = this.filter.toLowerCase()
      return this.episodes.filter((ep) => {
        return ep.fullname.toLowerCase().indexOf(lowerCaseFilter) > -1
      })
    },
    routeId () {
      return this.$route.params.episodeId
    }
  },
  methods: {
    searchEvent () {
      if (this.filter.length > 0) {
        this.filter = ''
      } else {
        this.$refs.filter.focus()
      }
    },
    initWithEpisodeId (episodeId) {
      const ep = this.episodes.find((episode) => {
        return episode.id === episodeId
      })
      if (ep) {
        this.addEpisode(ep)
      }
    },
    addEpisode (episode, noScroll) {
      this.selectEpisode(episode, noScroll)
      this.formerEpisodes.push(episode)
    },
    selectEpisode (episode, noScroll) {
      if (this.filteredEpisodes.length === 0) {
        return
      }
      this.$emit('selectEpisode', episode)
      if (!noScroll) {
        // scroll on the next frame for when we use the browser's navigation
        setTimeout(() => {
          scrollTo(episode.id)
        }, 0)
      }
      this.$router.push({ name: 'episode', params: { episodeId: episode.id } })
      document.title = `${episode.name} | Les deux minutes du peuple`
    },
    next (isRandom) {
      if (isRandom) {
        const episode = this.randomNext()
        this.formerEpisodes.push(episode)
      } else if (this.currentEpisode) {
        const index = this.filteredEpisodes.indexOf(this.currentEpisode)
        var newIndex = index + 1
        if (newIndex > this.filteredEpisodes.length - 1) {
          newIndex = newIndex - this.filteredEpisodes.length
        }
        this.addEpisode(this.filteredEpisodes[newIndex])
      } else {
        this.addEpisode(this.filteredEpisodes[0])
      }
    },
    previous (isRandom) {
      if ((isRandom && this.formerEpisodes.length > 1) || this.formerEpisodes.length > 1) {
        // if at least one episode in history
        this.formerEpisodes.pop()
        this.selectEpisode(this.formerEpisodes[this.formerEpisodes.length - 1])
      } else if (this.currentEpisode) {
        // If is random and no history, or is not random
        const index = this.filteredEpisodes.indexOf(this.currentEpisode)
        var newIndex = index - 1
        if (newIndex < 0) {
          newIndex = this.filteredEpisodes.length + newIndex
        }
        this.selectEpisode(this.filteredEpisodes[newIndex])
      } else {
        // if no selected episode
        this.selectEpisode(this.filteredEpisodes[this.filteredEpisodes.length - 1])
      }
    },
    randomNext () {
      const randomIndex = Math.floor(Math.random() * this.filteredEpisodes.length)
      const episode = this.filteredEpisodes[randomIndex]
      this.selectEpisode(episode)
      return episode
    }
  },
  mounted () {
    this.$refs.filter.addEventListener('focus', (event) => {
      this.$store.commit('enableKeyboardControls', false)
    })
    this.$refs.filter.addEventListener('focusout', (event) => {
      this.$store.commit('enableKeyboardControls', true)
    })
  },
  watch: {
    routeId (routeId) {
      if (routeId !== this.currentEpisode.id) {
        const ep = this.episodes.find((episode) => {
          return episode.id === routeId
        })
        if (ep) {
          this.selectEpisode(ep)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.top {
  position: fixed;
  top: 0;
  max-width: 500px;
  height: 45px;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: $white;

  .icon-search {
    height: 100%;
    padding-right: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    svg {
      height: 20px;
      path {
        fill: $violet;
      }
    }
  }
}

.filter {
  width: 100%;
  padding: 0 15px;
  border: none;
  outline: none;
  background-color: $white;
}

.episode {
  background-color: $darkviolet;
  color: $white;
  padding: 15px;
  cursor: pointer;

  &[data-pair] {
    background-color: $violet
  }

  &:hover {
    background-color: $darkerviolet;
  }

  &[data-current] {
    background-color: $red;
  }
}

.category {
  color: $white-tr;
  font-size: 0.8em;
  margin-left: 5px;
}

.no-episodes {
  padding: 15px;
  text-align: center;
}
</style>
